module.exports = __webpack_public_path__ + "media/images/sale_crm/inventory-23f99745fea798b52a10ca30a3a605f9.svg";